<template>
  <layout>
    <div slot="content">
      <i-card title="预约场次明细列表">
        <div slot="content">
          <el-form :inline="true" size="small" style="text-align: right">
            <el-form-item>
              <el-date-picker start-placeholder="班次开始日期" end-placeholder="班次结束日期"
                              v-model="filter.date_range" value-format="yyyy-MM-dd" type="daterange"/>
            </el-form-item>
            <el-form-item>
              <el-select v-model="filter.wx_qr_code_expired" placeholder="群二维码是否过期">
                <el-option label="未过期" value="1"/>
                <el-option label="已过期" value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadPageList">查找</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table v-loading="loading" :data="userList" :border="true">
            <el-table-column label="班次日期">
              <div slot-scope="scope" class="opt-container">
                {{ scope.row.date }} ({{ scope.row.week_day }})
              </div>
            </el-table-column>
            <el-table-column prop="guide_user_name" label="讲解员"/>
            <el-table-column prop="apply_count" label="报名人数"/>
            <el-table-column prop="stock" label="当前库存"/>
            <el-table-column prop="wx_qun_name" label="微信群名称"/>
            <el-table-column prop="wx_qr_code_expired_at" label="群二维码过期时间"/>
            <el-table-column prop="created_at" label="添加时间"/>
            <el-table-column label="操作" fixed="right">
              <div slot-scope="scope" class="opt-container">
                <el-button size="mini" type="primary" @click="showEditDialog(scope.row)">编辑</el-button>
              </div>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <el-pagination background :current-page="pageInfo.current_page" layout="prev, pager, next" :page-size="15"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
      <!--编辑排班-->
      <el-dialog title="编辑班次" :visible.sync="editRow.showDialog" width="30%">
        <div>
          <el-form :model="editRow.data" :rules="editRow.rules" size="small" label-width="130px">
            <el-form-item label="群二维码" prop="wx_qr_code">
              <i-upload v-model="editRow.data.ori_wx_qr_code" :max-files="1"></i-upload>
            </el-form-item>
            <el-form-item label="二维码过期时间" prop="wx_qr_code_expired_at">
              <el-date-picker v-model="editRow.data.wx_qr_code_expired_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                              placeholder="请选择二维码过期时间" style="width: 100%"/>
            </el-form-item>
            <el-form-item label="群名称" prop="wx_qun_name">
              <el-input required v-model="editRow.data.wx_qun_name"></el-input>
            </el-form-item>
            <el-form-item label="库存" prop="stock">
              <el-input required v-model="editRow.data.stock"></el-input>
            </el-form-item>
            <el-form-item label="讲解员" prop="guide_user_id">
              <el-select v-model="editRow.data.guide_user_id" placeholder="请选择" style="width: 100%">
                <el-option v-for="guideUser in guideList" :key="guideUser.user_id+'_user'"
                           :disabled="guideUser.status !== 1" :label="guideUser.name+'('+guideUser.mobile+')'"
                           :value="guideUser.user_id"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editRow.showDialog = false">取 消</el-button>
          <el-button type="primary" @click="doEditRow" :loading="postLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "user-list",
  data() {
    return {
      userList: [],
      loading: false,
      postLoading: false,
      playId: "",
      guideList: [],
      pageInfo: {
        current_page: 1,
        total: 0
      },
      teamPageInfo: {
        current_page: 1,
        total: 0
      },
      filter: {
        date_range: "",
        wx_qr_code_expired: "",
      },
      editRow: {
        showDialog: false,
        data: {date: "", stock: "", wx_qun_name: "", wx_qr_code: "", guide_user_id: "", ori_wx_qr_code: []},
        rules: {
          wx_qun_name: [
            {required: true, message: '请输入群名称', trigger: 'blur'},
          ],
          wx_qr_code: [
            {required: true, message: '请上传微信群二维码', trigger: 'blur'},
          ],
          stock: [
            {required: true, message: '请输入库存', trigger: 'blur'},
          ],
          wx_qr_code_expired_at: [
            {required: true, message: '请选择二维码过期时间', trigger: 'blur'},
          ],
          guide_user_id: [
            {required: true, message: '请选择讲解员', trigger: 'blur'},
          ],
        }
      },
    }
  },
  methods: {
    loadPageList: function () {
      this.loading = true;
      this.$http.request('playDailyCalender', {
        page: this.pageInfo.current_page,
        play_id: this.playId,
        date_range: this.filter.date_range,
        wx_qr_code_expired: this.filter.wx_qr_code_expired,
      }).then(res => {
        this.userList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
      })
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.loadPageList();
      window.scrollTo(0, 0);
    },

    //编辑信息
    showEditDialog: function (row) {
      this.editRow.data = row;
      this.editRow.showDialog = true;
    },
    doEditRow: function () {
      this.postLoading = true;
      try {
        this.editRow.data.wx_qr_code = this.editRow.data.ori_wx_qr_code[0].path || "";
      }catch (e){
        this.editRow.data.wx_qr_code = '';
      }
      let _self = this;
      this.$http.request('editPlayDaily', this.editRow.data).then(res => {
        this.postLoading = false;
        if (res.status === 'success') {
          _self.editRow.showDialog = false;
          this.loadPageList();
          _self.$message({
            message: res.message, type: 'success',
          });
        }
      })
    },
    //初始化讲解员列表
    initGuideList: function () {
      let _self = this;
      this.$http.request('guideOptions').then(function (res) {
        _self.guideList = res.data;
      })
    },

    reset: function () {
      window.location.reload();
    }
  },
  created: function () {
    this.playId = this.$route.query.play_id;
    this.loadPageList();
    this.initGuideList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/booking/play-daily-list.vue